import { useParams, useNavigate, Link } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../config/fbConfig';
import React, { useEffect, useState } from 'react';
import Logo from '../images/school_logo.png';

const ArchiveSessions = () => {
  const { sectionId } = useParams();
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const snap = await getDocs(collection(db, 'sessions'));
        const sorted = snap.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .sort((a, b) => {
            // Sort sessions like "2023/2024" in ascending order
            const getYear = s => parseInt(s.name?.split('/')?.[0]);
            return getYear(a) - getYear(b);
          });
        setSessions(sorted);
      } catch (error) {
        console.error('Error fetching sessions:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchSessions();
  }, []);

  return (
    <>
      <div className="top-elements row align-center space-between">
        <button onClick={() => navigate(-1)} className="back-link back-link1">
          <i className="fa-solid fa-arrow-left size3"></i>
        </button>
        <div className="column align-center justify-center">
          <img src={Logo} className="middle-logo" alt="logo" />
        </div>
        <Link to="#" className="home-link" onClick={() => window.location.reload()}>
          <i className="fa-solid fa-rotate-right size4"></i>
        </Link>
      </div>

      <div className="login-page-items column align-center">
        <div className='breadcrumb'>
          <button onClick={() => navigate(-1)} className="back-link back-link1 back-link2">
            Section &nbsp;&nbsp;&nbsp;<i className="fa-solid fa-angle-right font-gold size4"></i>
          </button>
          <button className="back-link back-link1 back-link2">
            Session
          </button>
        </div>
        <h2 className="manage-page-heading manage-page-heading-select caps size4">Select Session</h2>
        <div className="scroll-fixed scroll-fixed1">
          <div className="class-list class-list-d scrollable class-items">
            {loading ? (
              <p className="loading-text male-female-stat">Loading sessions...</p>
            ) : sessions.length === 0 ? (
              <p className="empty-text male-female-stat">No sessions available.</p>
            ) : (
              sessions.map(session => (
                <div key={session.id}>
                  <button
                    className="class-item class-item1 class-item1-d"
                    onClick={() => navigate(`/archives/${sectionId}/${session.id}`)}
                  >
                    {session.name}
                  </button>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ArchiveSessions;
